import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
    updateIntegrationContract,
    updatePayPerCallContract,
    updateSubscriptionContract,
} from 'src/openapi/admin/apis/ContractControllerApi';
import {updateCreditBalance} from 'src/openapi/admin/apis/CreditControllerApi';
import {downloadReport} from 'src/openapi/admin/apis/CreditHistoryReportControllerApi';
import {PricingModel} from 'src/openapi/admin/models/PricingModel';
import {useAppDispatch} from 'src/store/hooks';

import {getAccountId} from '../../../../services/selectors';
import {clearError} from '../services/actions';

import type {OnUpdateContractInfo, OnUpdateCredits} from '../typedef';

export const usePricingActions = () => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();
    const accountId = useSelector(getAccountId);

    const onDownload = useCallback(() => {
        apiDispatch(downloadReport({accountId}));
    }, [accountId]); // eslint-disable-line react-hooks/exhaustive-deps

    const onCloseError = useCallback(() => {
        dispatch(clearError());
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onUpdateContractInfo: OnUpdateContractInfo = useCallback(({pricingModel, ...data}) => {
        switch (pricingModel) {
            case PricingModel.INTEGRATION:
                apiDispatch(updateIntegrationContract({integrationContractUpdate: data, accountId}));
                break;

            case PricingModel.SUBSCRIPTION:
                apiDispatch(updateSubscriptionContract({subscriptionContractUpdate: data, accountId}));
                break;

            case PricingModel.PAY_PER_CALL:
                apiDispatch(updatePayPerCallContract({
                    payPerCallContractUpdate: {
                        contractId: data.contractId,
                        contractNumber: data.contractNumber,
                        startDate: data.startDate,
                    }, accountId}));
                break;

        }
    }, [accountId]); // eslint-disable-line react-hooks/exhaustive-deps

    const onUpdateCredits: OnUpdateCredits = useCallback(data => {
        apiDispatch(updateCreditBalance({credits: data, accountId}));
    }, [accountId]); // eslint-disable-line react-hooks/exhaustive-deps

    return ({
        onDownload,
        onCloseError,
        onUpdateCredits,
        onUpdateContractInfo,
    });
};
